<template>
    <div class="container">
        <form v-on:submit.prevent="onSubmit">   
            <h1>{{'Create Plan' | translate}}</h1>
            <!-- General Plan Settings Begin-->
            <div class="form-group">
                <label>{{'Plan Name' | translate}}</label>
                <input type="text" v-model="ui.planName" class=form-control>
                <small class="form-text text-muted">{{'The name of the ticket.' | translate}}</small>
            </div>
            <div class="form-group">
                <label>{{'Plan Type' | translate}}</label>
                <select v-model="ui.planType" class=form-control>
                    <option disabled value="">{{'Please select One' | translate}}</option>
                    <option v-for="(planType,key) in planTypes" :key="key" :value="key">{{$t(planType.name)}}</option>
                </select>
                <small class="form-text text-muted">{{'Each type has a unique view.' | translate}}</small>
            </div>
            <!-- Sub Plan Type BEGIN -->
            <div v-if="ui.planType && planTypes[ui.planType].formats" class="form-group">
                <label>{{'Plan Format' | translate}}</label>
                <select v-model="ui.planFormat" class=form-control>
                    <option disabled value="">{{'Please select One' | translate}}</option>
                    <option v-for="(format,key) in planTypes[ui.planType].formats" :key="key" :value="key">{{$t(format)}}</option>
                </select>
                <small class="form-text text-muted">{{'Each type has a unique view.' | translate}}</small>
            </div>
            <!-- Sub Plan Type END -->
            <div class="form-group">
                <label>{{'Plan Description' | translate}}</label>
                <textarea rows="6" v-model="ui.planDescription" class=form-control></textarea>
                <small class="form-text text-muted">{{'Detailed usage of the ticket.' | translate}}</small>
            </div>
            <div class="form-group">
                <label>{{'Plan Expiration' | translate}}</label>
                <input type="text" v-model="ui.expiration" class=form-control>
                <small class="form-text text-muted">{{'Ticket can not be used after that day.' | translate}}</small>
            </div>
            <div class="form-group">    
                <label>{{'Fanpage ID' | translate}}</label>
                <input type="text" v-model="ui.fanPageID" class=form-control>
                <small class="form-text text-muted">{{'The ticket will send from this fanpage to customer. (Need further settings)' | translate}}</small>
            </div>
            <!-- General Plan Settings END-->
            <!-- General Image upoads BEGIN-->
            <div v-if="!isSubmitted" class="row form-group">
                <div class="col-sm-4 ">
                    <div class="card">
                        <div class="card-header">
                            {{'Plan Front Image (required)' | translate}}
                        </div>
                        <img class="card-img-top" :src="previewImg.front">
                        <div class="card-footer">
                           <div class="custom-file">
                                <input class="custom-file-input btn" type="file" @change="processFile($event,'front')" accept="image/*" capture="camera"> 
                                <label class="custom-file-label" :style='"--file-content:\""+$t("Browse")+"\""'>{{'Choose File' | translate}}</label>
                           </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isSubmitted" class="col-sm-4 ">
                    <div  class="card">
                        <div class="card-header">
                            {{'Plan Back Image (Back)' | translate}}
                        </div>
                        <img class="card-img-top" :src="previewImg.back">
                        <div class="card-footer">
                           <div class="custom-file">
                                <input class="custom-file-input btn" type="file" @change="processFile($event,'back')" accept="image/*" capture="camera"> 
                                <label class="custom-file-label" :style='"--file-content:\""+$t("Browse")+"\""'>{{'Choose File' | translate}}</label>
                           </div>
                        </div>
                    </div>
                </div>
                <div  class="col-sm-4 ">
                    <div class="card">
                        <div class="card-header">
                            {{'Plan Redeemed Image (Suggested)' | translate}}
                        </div>
                        <img class="card-img-top" :src="previewImg.redeemed">
                        <div class="card-footer">
                           <div class="custom-file">
                                <input class="custom-file-input btn" type="file" @change="processFile($event,'redeemed')" accept="image/*" capture="camera"> 
                                <label class="custom-file-label"  :style='"--file-content:\""+$t("Browse")+"\""'>{{'Choose File' | translate}}</label>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- General Image upoads END-->
            <!-- Dynamic Coupon Code Settings BEGIN-->
            <div v-if="ui.planType=='dynamic-coupon-code'" class="form-group">
                <label>{{'Import Dynamic Coupon Code List' | translate}}</label>
                <div class="custom-file">
                        <input class="custom-file-input btn" type="file" @change="processCsvFile($event.target.files[0],csvObj)" accept=".csv"> 
                        <label class="custom-file-label"  :style='"--file-content:\""+$t("Browse")+"\""'>{{'Upload Batch CSV File or Paste Coupon Code List' | translate}}</label>
                </div>
                <textarea rows="6" v-model="dynamicCouponCodeList" class=form-control></textarea>
                <small class="form-text text-muted">{{'The amount of coupon code will be the amount of tickets you can issue' | translate}}</small>
                <span>
                    {{$t('Already imported {number} codes.',{'number':Object.values(csvObj.data).filter(a=>a.code).length})}}
                </span>
            </div>
            <!-- Dynamic Coupon Code Settings END -->
            <!-- Advanced Settings BEGIN -->
            <h5 @click="ui.toggleAdvanced=!ui.toggleAdvanced">{{'Advanced Settings' | translate}}</h5>
            <div v-if="ui.toggleAdvanced" class="row form-group" >
                <div class="col-sm-10">
                    <label>{{'Push Message Template' | translate}}</label>
                    <textarea rows="6" v-model="ui.advanced.facebookMessageTemplate" class=form-control>
                    </textarea>
                    <small class="form-text text-muted">{{'Should be a valid JSON Object' | translate}}</small>
                </div>
            </div>
            <!-- Advanced Settings END -->
            <!-- Submit BEGIN -->
            <div class="row form-group">
                <div class="col-sm-10">
                    <button :disabled="!validated" v-if="!isSubmitted" @click.prevent="onSubmit" class="btn " :class="{'btn-primary':validated,'btn-light':!validated}" >{{'Submit' | translate}}</button>
                    <div v-if="isSubmitted&&!isAllUploaded">{{'Waiting for uploading...' | translate}}
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="{'width': progress+'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="isSubmitted&&isAllUploaded" class="col-sm-10">
                    <p>{{'Find your plan here:'  | translate}}</p>
                    <a  :href="returnURL"  >{{returnURL}}</a>
                </div> -->
            </div>
            <!-- Submit END -->
        </form>
        <app-modal 
            :options="{
                'isAlert':isAlert,
                'modalTitle':modalTitle,
                'modalText':modalText
            }" @modalEvent="onModalEvent">
        </app-modal>
    </div>
</template>

<script>
import Modal from './Modal.vue';//TODO move to mixin
import Papa from 'papaparse';//TODO move to mixin
import firebase from 'firebase';
    export default {
        components:{//TODO move to mixin
            appModal:Modal
        },
        data(){
            return {
                planObj:{
                    planImages:{}
                },
                progress:0,
                currentUser:null,
                userConfig:null,
                isAlert:false,//TODO move to mixin
                modalTitle:'',//TODO move to mixin
                modalText:'',//TODO move to mixin
                ui:{
                    planName:'',
                    planType:'',
                    planFormat:'',
                    planDescription:'',
                    expiration:'',
                    fanPageID:'',
                    toggleAdvanced:false,
                    advanced:{
                        facebookMessageTemplate:''
                    }
                },
                csvObj:{
                    data:''
                },
                dynamicCouponCodeList:[],
                previewImg:{
                    front:'https://dummyimage.com/1280x640/888888/ffffff&text="'+this.$t('Ticket Front Image')+'"',
                    back:'https://dummyimage.com/1280x640/888888/ffffff&text="'+this.$t('Ticket Back Image')+'"',
                    redeemed:'https://dummyimage.com/1280x640/888888/ffffff&text="'+this.$t('Ticket Redeemed Image')+'"'
                },
                isSubmitted: false,
                isAllUploaded:false,
                planID:'',
                files:{
                    front:null,
                    back:null,
                    redeemed:null
                },
                validated:false,
                planTypes:{
                    'ticket':{
                        name:'Ticket',
                        issueMethod:'issue'
                    },
                    'card':{
                        name:'Card',
                        issueMethod:'issue'
                    },
                    'dynamic-coupon-code':{
                        name:'Dynamic Coupon Code',
                        issueMethod:'stock',
                        formats:{
                            'text': 'Text code',
                            'barcode-CODE39': 'Barcode CODE39',
                            'qrcode': 'QRcode'
                        }
                    },
                    'scratch-card':{
                        name:'Scratch Card',
                        issueMethod:'issue'
                    }
                }
                
            }
        },
        watch:{
            userConfig(){
                this.ui.fanPageID = this.userConfig.fanPageID;
            },
            currentUser(){
                this.getUserConfig();
            },
            previewImg:{
                handler(){//Just to make vue watch deeper in 
                },
                deep:true
            },
            files:{
                handler(){
                    this.validated = (this.ui.planName != '')&&(this.ui.planType != '')&&(this.files.front!=null);
                },
                deep:true
            },
            ui:{
                handler(){
                    this.validated = (this.ui.planName != '')&&(this.ui.planType != '')&&(this.files.front!=null);
                },
                deep:true
            },
            csvObj:{ // TODO move to mixins (csv two way binding)
                handler(){
                    this.dynamicCouponCodeList = Object.values(this.csvObj.data).map(a=>a.code).join('\n');
                },
                deep:true
            },
            dynamicCouponCodeList(){ // TODO move to mixins (csv two way binding)
                this.csvObj.data = this.dynamicCouponCodeList.split('\n').map(a=>{return {'code':a}});
            }
        },
        computed: {
            planIssueMethod(){
                return this.planTypes[this.ui.planType].issueMethod
            },
            returnURL(){
                return window.location.origin + '/plan/'+ this.planID;
            }
        },
        methods:{
            onSubmit() {
                var self = this;
                var uploadTasks =[];
                this.createPlan()
                .then(()=>{
                    Object.keys(self.files).forEach(key => {
                        uploadTasks.push(self.uploadImage(key));
                    });
                    console.log('uploadTasks:');
                    console.log(uploadTasks);
                    return Promise.all(uploadTasks)
                        .then(function(){
                            self.isAllUploaded = true;
                        });
                })
                .then(()=>{
                    if(self.planIssueMethod == 'stock' && self.ui.planType=='dynamic-coupon-code'){
                        self.batchIssueStockTickets(
                            self.csvObj.data.filter(a=>a.code).map(d=>{return {dynamicCouponCode: {code: d.code}}})
                        );
                    }
                })
                .then(()=>{
                    self.$router.push('plan/'+self.planID);
                })
                .catch((error)=>self.modalAlert(self.$t('Create Plan'),self.$t('Creating Plan Failed')+error));
                this.isSubmitted = true;
                
            },
            processCsvFile(file,obj){
                Papa.parse(file, {
                    worker: false,
                    header:true,
                    step:null,
                    complete: function(results) {
                        obj.data = results.data;
                        // console.log("Row:", results.data);
                    }
                });

            },
            createPlan(){
                console.log('Creating Plan...');
                var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/plans');
                var newPlanKey = databaseRef.push().key;
                var self =this;
                this.planObj['owner'] = this.currentUser.uid;
                this.planObj['planID'] = newPlanKey;
                this.planObj['fanPageID'] = this.ui.fanPageID;
                this.planObj['planName'] = this.ui.planName;
                this.planObj['planType'] = this.ui.planType;
                this.planObj['expiration'] = this.ui.expiration;
                this.planObj['planDescription'] = this.ui.planDescription;
                this.planObj['planIssueMethod'] = this.planIssueMethod;
                this.planObj['status'] = 'launch';
                this.planObj['messageTemplates'] = {messenger:this.ui.advanced.facebookMessageTemplate};
                var updates ={};
                Object.keys(this.planObj).forEach((key)=>{
                    updates[newPlanKey+'/'+key] = this.planObj[key];
                });
                
                return new Promise((resolve, reject) => { 
                    databaseRef.update(updates, function(error) {
                        if (error) {
                            console.log("Creating Plan failed...");
                            reject(error);
                        } else {
                            console.log("Creating Plan success!");
                            self.planID = newPlanKey;
                            resolve(newPlanKey);
                            
                        }
                    });
                });
            },
            processFile(e,value){
                this.files[value] = e.target.files[0];
                var self = this;
                var reader = new FileReader();
                reader.addEventListener('load',function(){
                    self.previewImg[value] = reader.result;
                });
                if (this.files[value]) {
                    reader.readAsDataURL(this.files[value]);
                }

            },
            uploadImage(value){
                
                var file = this.files[value];
                if(file==null)
                    return;
                var self = this;
                var storageRef = firebase.storage().ref();
                var fileName = this.files[value].name;
                var metadata = {
                    'contentType': this.files[value].type
                };
                return new Promise((resolve,reject)=>{

                    console.log('Uploading Image...' + fileName.split('.')[0] +'.'+ fileName.split('.')[1]);
                    var uploadTask = storageRef.child('/images/'+self.planID+'/'+ value +'.' + fileName.split('.')[1]).put(file, metadata);
                    // Listen for state changes, errors, and completion of the upload.
                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                        function(snapshot) {
                            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                            self.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                            console.log('Upload is ' + self.progress + '% done');
                            switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused');
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log('Upload is running');
                                break;
                            }
                        }, function(error) {
                            // A full list of error codes is available at
                            // https://firebase.google.com/docs/storage/web/handle-errors
                            switch (error.code) {
                                case 'storage/unauthorized':
                                console.log("User doesn't have permission to access the object");
                                break;

                                case 'storage/canceled':
                                console.log("User canceled the upload");
                                break;
                                case 'storage/unknown':
                                console.log("Unknown error occurred, inspect error.serverResponse");
                                break;
                            }

                        },
                        function() {
                            console.log('Upload success');
                            // Upload completed successfully, now we can get the download URL
                            uploadTask.snapshot.ref.getDownloadURL()
                            .then(function(downloadURL) {
                                console.log('File available at', downloadURL);
                                self.planObj.planImages[value] = downloadURL;
                                return downloadURL;
                            })
                            .then(function(url){
                                console.log('Catching downloadURL:'+url);
                                firebase.database().ref('users/' +self.currentUser.uid+ '/plans/' + self.planID + '/planImages').update(self.planObj.planImages,function(error){
                                    if (error) {
                                        console.log("Register Image download link failed...");
                                        reject(error);
                                    } else {
                                        console.log('Register Image download link success');
                                        resolve(url);
                                    }             
                                });
                            });
                        });
                });
            },
            modalAlert(title,text){//TODO move to mixin
                this.modalTitle = title;
                this.modalText = text;
                this.isAlert = true;
            },
            onModalEvent(event){//TODO move to mixin
                console.log(event);
                this.isAlert = false;
                this.modalTitle = '';
                this.modalText = '';
            },
            getCurrentUser(){//Warning: massive duplicate code
                var self =this;
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        self.currentUser = user;
                    } else {
                        console.log('No user has signed in.');
                    }
                })
            },
            getUserConfig(){//Warning massive duplicate code
                console.log('Fetching User Config');
                var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/config');
                var self = this;
                databaseRef.once('value')
                    .then(function(snapshot) {
                        
                        if(snapshot!=null){
                            console.log('Loaded User config');
                            self.userConfig = snapshot.val();
                            
                        }else{
                            console.log('User config not exists');
                            
                        }
                        
                    },function(error){
                        console.log('Loading User config  error: ' + error);
                        reject(error);
                    });

            },
            batchIssueStockTickets(arr){
                arr.forEach((a)=>{
                        this.issueStockTicket(a);                    
                })
            },
            issueStockTicket(obj={}){
                console.log('Issuing stock ticket: ',obj)
                var self = this;
                var ticketObj ={};
                ticketObj = JSON.parse(JSON.stringify(this.planObj));
                console.log('[issueStockTicket] this.planObj',this.planObj)
                delete ticketObj.messageTemplates;
             
                var ticketRef = firebase.database().ref('users/' +this.currentUser.uid+ '/tickets/').push();
                Object.assign(ticketObj,obj)
                obj.ticketID = ticketRef.key;
                obj.ticketURL = 'https://' + process.env.VUE_APP_FIREBASE_AUTHDOMAIN + '/ticket/'+this.currentUser.uid+'|'+obj.ticketID;
                ticketObj['owner'] = this.planObj.planID;
                ticketObj['ticketID'] = obj.ticketID;
                ticketObj['ticketURL'] = obj.ticketURL;
                ticketObj['status'] = 'stock';
                console.log('Issuing stock ticket: ticketobj',ticketObj)

                var updates ={};
                // updates['users/' + this.currentUser.uid + '/customers/'+obj.customerID+'/tickets/' + obj.ticketID] = ticketObj;
                updates['users/' + this.currentUser.uid + '/plans/'+this.planObj.planID+'/stockTickets/' + obj.ticketID] = ticketObj;
                updates['users/' + this.currentUser.uid + '/tickets/' + obj.ticketID] = ticketObj;
            
                return firebase.database().ref().update(updates)
                    .then(function(){
                        return obj;
                    })
            },
            init(){
                this.ui.advanced.facebookMessageTemplate = JSON.stringify({
                        'attachment':{
                            'type':'template',
                            'payload':{
                                'template_type':'generic',
                                'sharable':false,
                                'elements':[
                                    {
                                        'title':'%title%',
                                        'image_url':'%image_url%',
                                        'subtitle':'%subtitle%',
                                        'default_action':{
                                            'type' : 'web_url',
                                            'url' : '%url%',
                                            'messenger_extensions' : true,
                                            'webview_height_ratio' : 'tall',
                                            'webview_share_button' : 'hide',
                                        }
                                    }
                                ]
                            }
                        }
                    });
            }

        },
        mounted(){//Warning: massive duplicate code
            this.getCurrentUser();
            this.init();
        }
    }
</script>
<style scoped>
.custom-file-label::after {
    content:var(--file-content);
}
</style>
